"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_AGE = 102;
exports.SUPERANNUATION_TAX_RATE = 0.15;
exports.SUPERANNUATION_TAX_RATE_HIGH_EARNER = 0.3;
exports.SUPERANNUATION_EXCESSIVE_TAX_RATE = 0.465;
exports.PENSION_REBATE_RATE = 0.15;
exports.FULL_TIME_DAYS_PER_WEEK = 5;
exports.MAXIMUM_TTR_DRAWING_RATE = 0.1;
exports.FORTNIGHTS_PER_YEAR = 26.09;
exports.AGE_CEASE_DEFERRED_RETIREMENT = 55;
//# sourceMappingURL=Constants.js.map